
define('text!templates/components/manual_payment_transaction/manual_payment_transactions.html',[],function () { return '<div class="list-container">\n\n</div>';});

